import React from "react";
import classNames from "classnames";
import { useStableDomId } from "../../../useStableDomId";

interface IEmailBuilderSettingsGroupProps {
  title?: string;
  titleTone?: "default" | "subtle";
  hint?: string;
  titleActions?: React.ReactNode;
  children: React.ReactNode;
}

export function EmailBuilderSettingsGroup(props: IEmailBuilderSettingsGroupProps) {
  const { title, titleTone = "default", hint, titleActions, children } = props;
  const titleId = useStableDomId("email-builder-settings-group");
  const resolvedTitleId = title ? titleId : undefined;

  return (
    <div
      className="email-builder-settings-group"
      role="group"
      aria-labelledby={resolvedTitleId}
    >
      {title ? (
        titleActions ? (
          <div className="email-builder-settings-group__header">
            <div
              id={titleId}
              className={classNames("email-builder-settings-group__title", {
                "email-builder-settings-group__title--subtle": titleTone === "subtle",
              })}
            >
              {title}
            </div>
            <div className="email-builder-settings-group__title-actions">{titleActions}</div>
          </div>
        ) : (
          <div
            id={titleId}
            className={classNames("email-builder-settings-group__title", {
              "email-builder-settings-group__title--subtle": titleTone === "subtle",
            })}
          >
            {title}
          </div>
        )
      ) : null}
      {hint ? <p className="email-builder-settings-group__hint">{hint}</p> : null}
      <div className="email-builder-settings-group__fields">{children}</div>
    </div>
  );
}

interface IEmailBuilderSettingsInlineFieldProps {
  label: string;
  children: React.ReactNode;
  controlClassName?: string;
}

export function EmailBuilderSettingsInlineField(props: IEmailBuilderSettingsInlineFieldProps) {
  const { label, children, controlClassName } = props;
  const labelId = useStableDomId("email-builder-settings-inline-field");

  return (
    <div className="email-builder-settings-inline-field" role="group" aria-labelledby={labelId}>
      <div id={labelId} className="email-builder-settings-inline-field__label">
        {label}
      </div>
      <div
        className={classNames("email-builder-settings-inline-field__control", controlClassName)}
      >
        {children}
      </div>
    </div>
  );
}
